/**
 * 车辆信息实体
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    rff,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '车辆信息';

const Option = Select.Option;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [licenseNumber, setLicenseNumber] = useState('');
    const [purchaseTime, setPurchaseTime] = useState(currentDate);
    const [name, setName] = useState('');
    const [model, setModel] = useState('');
    const [currentMileage, setCurrentMileage] = useState(1);
    const [username, setUsername] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [uses, setUses] = useState('');
    const [description, setDescription] = useState('');

    const [mLists, setMLists] = useState([]);

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setLicenseNumber('');
        setPurchaseTime(currentDate);
        setName('');
        setModel('');
        setCurrentMileage(1);
        setUsername('');
        setDisplayname('');
        setUses('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setLicenseNumber(props.record.license_number);
            setPurchaseTime(props.record.purchase_time);
            setName(props.record.name);
            setModel(props.record.model);
            setCurrentMileage(props.record.current_mileage);
            setUsername(props.record.driver_username);
            setDisplayname(props.record.driver_displayname);
            setUses(props.record.uses);
            setDescription(props.record.description);
        }
    }, [props.record]);


    useEffect(() => {
        const params = {
            'rss': 'list',
            'page_size': CNF.pageSize * 100,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.sealApi}users${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    setMLists(data.dat);
                } else {
                    setMLists([])
                }
            }
        })
    }, [])


    const ok = () => {
        //  参数校验
        if (licenseNumber === '') {
            message.error('车牌号码不能为空！');
            return;
        }
        if (name === '') {
            message.error('车辆名称不能为空！');
            return;
        }
        setLoading(true);
        //  执行创建
        $.ajax({
            url: CNF.api + 'cars' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'license_number': licenseNumber,
                'name': name,
                'model': model,
                'driver_username': username,
                'driver_displayname': displayname,
                'uses': uses,
                'purchase_time': purchaseTime,
                'current_mileage': currentMileage,
                'description': description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });

    };


    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>{rff}车牌号码</Col>
                    <Col span={11} offset={2}>{rff}车辆名称</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入'
                            value={licenseNumber}
                            onChange={(e) => setLicenseNumber(e.target.value)}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder='请输入'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>车辆型号</Col>
                    <Col span={11} offset={2}>购买时间</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入'
                            value={model}
                            onChange={(e) => setModel(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <DatePicker
                            placeholder='请选择日期'
                            style={{ width: '100%' }}
                            value={dayjs(purchaseTime, 'YYYY-MM-DD')}
                            onChange={(_, dateString) => setPurchaseTime(dateString)}
                            disabled={loading}
                        /></Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>驾驶人员</Col>
                    <Col span={11} offset={2}>当前里程</Col>
                    <Col span={11}>
                        <Select
                            showSearch
                            placeholder='请选择驾驶人员'
                            style={{ width: '100%' }}
                            onChange={(value, option) => {
                                setUsername(value);
                                setDisplayname(option.props.children === '' ? '' : option.props.children);
                            }}
                            disabled={loading}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            {
                                mLists.length && mLists.map((item) => {
                                    return <Option key={item['username']} value={item['username']}>{item['displayname']}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={11} offset={2}>
                        <InputNumber
                            suffix='km'
                            min={1}
                            step={1}
                            style={{ width: '100%' }}
                            onChange={(value) => setCurrentMileage(value)}
                            value={currentMileage}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>车辆用途</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={uses}
                            onChange={(e) => setUses(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            rows={2}
                            autoSize={{ minRows: 3, maxRows: 12 }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity